jQuery(document).ready(function($) {
    'use strict';

    /**
     * This one handles composite products.
     */
    (function() {
        if (!window.kilamobler_add_to_cart_params ||
            window.kilamobler_add_to_cart_params.product_type !== 'composite'
        ) {
            return;
        }

        $('.composite_data').on('wc-composite-initializing', onInitialize);

        function onInitialize(_, composite) {
            window.composite = composite;

            const onTotalsChange = debounce(function() {
                getWrapper().block({
                    message: null,
                    overlayCSS: {
                        opacity: 0,
                    },
                });

                const configuration = composite.api.get_composite_configuration();
                const quantity = parseInt(
                    composite.$composite_quantity.val(),
                    10,
                );

                for (let key in configuration) {
                    configuration[key].quantity =
                        configuration[key].quantity * quantity;
                }

                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: '/?wc-ajax=check_availability_and_delivery_time',
                    data: {
                        product_id: window.kilamobler.product.id || 0,
                        configuration: configuration,
                    },
                    success: onDeliveryTimeUpdateSuccess,
                    always: function() {
                        getWrapper().unblock();
                    },
                });
            }, 500, false);

            const onQuantityChanged = debounce(function(component) {
                var id;
                var type = component.get_selected_product_type();
                switch (type) {
                    case 'variable':
                        id = component.get_selected_variation();
                        break;
                    case 'simple':
                    default:
                        id = component.get_selected_product();
                        break;
                }

                const $stock = component.$component_inner.find('.stock');
                $stock.animate({
                    opacity: 0.3,
                }, 250);

                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: '/?wc-ajax=check_composite_component_stock_status',
                    data: {
                        configuration: {
                            id: id,
                            quantity: component.get_selected_quantity(),
                        },
                    },
                    success: function(response) {
                        if (!response || response.error) {
                            return;
                        }

                        var text;
                        switch (response.stock_status) {
                            case 'available-on-backorder':
                                text = 'Beställningsvara';
                                break;
                            case 'out-of-stock':
                                text = 'Slut för säsongen';
                                break;
                            case 'in-stock':
                            default:
                                text = 'Finns i lager';
                                break;
                        }

                        $stock.removeClass(
                            'in-stock available-on-backorder out-of-stock');
                        $stock.addClass(response.stock_status);
                        $stock.text(text);
                    },
                    complete: function() {
                        $stock.animate({
                            opacity: 1,
                        }, 250);
                    },
                });
            }, 500, false);

            $('body').on('product/quantity', onTotalsChange);

            composite.actions.add_action(
                'component_totals_changed',
                onTotalsChange,
            );

            composite.actions.add_action(
                'component_quantity_changed',
                onQuantityChanged,
            );

            composite.actions.add_action(
                'component_selection_changed',
                onTotalsChange,
            );
        }
    }());

    /**
     * This one handles simple products and variations.
     */
    (function() {
        if (!window.kilamobler_add_to_cart_params ||
            window.kilamobler_add_to_cart_params.product_type === 'composite'
        ) {
            return;
        }

        const $form = $('form.cart');
        const $quantity = $form.find('.qty');

        let storedVariationId = undefined;

        let xhr = null;

        // Need to debounce the callback because swatches triggers a second
        // `check_variations`-event, which will in turn lead to another
        // `found_variation`-event being triggered.
        $form.on('found_variation', debounce(onFoundVariation, 100, false));
        $('body')
            .on(
                'product/quantity',
                debounce(
                    function() {
                        getDeliveryTimeAndAvailability(storedVariationId);
                    },
                    100,
                    false,
                ),
            );

        function getDeliveryTimeAndAvailability(variationId = undefined) {
            if (xhr != null) {
                xhr.abort();
                xhr = null;
            }

            storedVariationId = variationId;

            getWrapper().block({
                message: null,
                overlayCSS: {
                    opacity: 0,
                },
            });

            xhr = $.ajax({
                type: 'POST',
                dataType: 'json',
                url: '/?wc-ajax=check_availability_and_delivery_time',
                data: {
                    product_id: window.kilamobler.product.id,
                    configuration: [
                        {
                            product_id: window.kilamobler.product.id,
                            quantity: $quantity.val(),
                            variation_id: variationId,
                        },
                    ],
                },
                success: onDeliveryTimeUpdateSuccess,
                complete: function() {
                    getWrapper().unblock();
                    xhr = null;
                },
            });
        }

        function onFoundVariation(e, variation) {
            getDeliveryTimeAndAvailability(variation.variation_id);
        }
    }());

    function getWrapper() {
        return $('.js--delivery-time');
    }

    function onDeliveryTimeUpdateSuccess(response) {
        if (!response || !response.availability) {
            return;
        }

        getWrapper().replaceWith(response.availability);
    }

    /**
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     */
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }
});
